type Props = {
    className?: string;
};

const PhoneFrameButtons = ({ className }: Props) => {
    return (
        <div className="absolute inset-0 hidden md:block z-20 pointer-events-none">
            <div
                className="absolute bg-phone-frame rounded-l-sm"
                style={{
                    left: "-6px",
                    width: "7px",
                    top: "176px",
                    height: "61px",
                }}
            />
            <div
                className="absolute bg-phone-frame rounded-l-sm"
                style={{
                    left: "-6px",
                    width: "7px",
                    top: "245px",
                    height: "61px",
                }}
            />
            <div
                className="absolute bg-phone-frame rounded-r-sm"
                style={{
                    right: "-26px",
                    width: "7px",
                    top: "176px",
                    height: "110px",
                }}
            />
        </div>
    );
};

export default PhoneFrameButtons;
